import { useTranslation } from 'next-i18next'
import { css } from 'styled-components'

import { breakpoints } from '@/styles'
import { useFilters } from '@/hooks/use-filters'

import SortDropdown from './sort-dropdown'

const optionsStyle = css`
  width: 300px;

  @media screen and (max-width: ${breakpoints.map}) {
    width: 250px;
  }

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    width: unset;
    left: 20px;
    right: 20px;
  }
`

const SortFilter = () => {
  const { t } = useTranslation()
  const [filters, setFilter] = useFilters()

  return (
    <SortDropdown
      t={t}
      sort={filters.sort}
      updateFilters={setFilter}
      optionsStyle={optionsStyle}
      display={t(
        'filters:b.listing_filter.edit.sort_by_lowercase.label',
        'Sort by'
      )}
      minimal
    />
  )
}

export default SortFilter
